














import { Component, Vue, Watch } from 'vue-property-decorator'

const INTERVAL_MS: number = 5000

@Component({
  components: {
    MiniLoader: require('@/components/MiniLoader').default
  },
  beforeRouteLeave(to, from, next) {
    (this as any).reset()

    next()
  }
})
export default class PaypalPending extends Vue {
  paymentStatusMessage: string = ''
  interval: any = null
  elapsed: number = 0

  async fetchSubscription() {
    this.$store.commit('subscription/reset')
    await this.$store.dispatch('subscription/fetchStatus')
  }

  reset() {
    clearInterval(this.interval)
  }

  async created() {
    this.interval = setInterval(async () => {
      this.elapsed += INTERVAL_MS

      if (!(this as any)._isDestroyed) {
        await this.fetchSubscription()

        if (this.elapsed > 120 * 1000) {
          this.reset()
          this.paymentStatusMessage = `It's taking longer than expected for your payment to be processed. Sometimes PayPal takes up to an hour but please contact us if it takes any longer.`
        }
      }
    }, INTERVAL_MS)
  }

  @Watch('$store.state.subscription.active', { immediate: true })
  async watchActive(active: boolean) {
    if (active) {
      await this.$router.push({
        name: 'subscription success'
      })
    }
  }
}
